/**
 * Routes. Section 12 - five pages behind one shell.
 *
 * `/impact` and `/scenarios` are routed in Phase 4 but show only their empty
 * states: their endpoints (`/impact`, `/whatif/library`) arrive in Phase 5 with
 * the analysis they report on. A page that invented figures before then would
 * be worse than one that says it has none.
 */

import { Navigate, Route, Routes } from 'react-router-dom'

import { Layout } from './components/Layout'
import Comparison from './pages/Comparison'
import Health from './pages/Health'
import Impact from './pages/Impact'
import Particles from './pages/Particles'
import ProvenancePage from './pages/Provenance'
import Results from './pages/Results'
import Scenarios from './pages/Scenarios'
import Alerts from './pages/Alerts'
import Sites from './pages/Sites'
import SiteDashboard from './pages/SiteDashboard'
import { RunScoped } from './components/RunScoped'
import Setup from './pages/Setup'
import Simulation from './pages/Simulation'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Part 11: India and every registered site is the landing page. */}
        <Route index element={<Navigate to="/overview" replace />} />
        <Route path="/site/:siteId" element={<SiteDashboard />} />
        <Route path="/overview" element={<Sites />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/simulation" element={<RunScoped page="Run"><Simulation /></RunScoped>} />
        <Route path="/results" element={<RunScoped page="Inundation"><Results /></RunScoped>} />
        <Route path="/compare-models" element={<RunScoped page="Comparison"><Comparison /></RunScoped>} />
        <Route path="/compare" element={<Navigate to="/compare-models" replace />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/impact" element={<RunScoped page="Impact"><Impact /></RunScoped>} />
        <Route path="/particles" element={<RunScoped page="3D View"><Particles /></RunScoped>} />
        <Route path="/data" element={<ProvenancePage />} />
        <Route path="/scenarios" element={<Scenarios />} />
        <Route path="/health" element={<Health />} />
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Route>
    </Routes>
  )
}
